import Button, { type ButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import type React from "react";

const theme = createTheme({
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					height: "56px",
					borderRadius: "10rem",
					fontFamily: "Montserrat",
					fontWeight: "600",
					lineHeight: "24px",
					// Add any additional default styles here
				},
				contained: {
					"&.Mui-disabled": {
						backgroundColor: "#F4F4F5 !important",
						color: "#71717A !important",
					},
					"&.MuiButton-containedPrimary": {
						backgroundColor: "#FFFFFF",
						color: "#0072CE",
						"&:hover": {
							backgroundColor: "rgba(255, 255, 255, 0.9)",
							color: "#0072CE",
						},
					},
					"&.MuiButton-containedError": {
						backgroundColor: "#FFFFFF",
						color: "#DC2626",
						"&:hover": {
							backgroundColor: "rgba(255, 255, 255, 0.9)",
							color: "#DC2626",
						},
					},
					"&.MuiButton-containedSecondary": {
						backgroundColor: "#0072CE",
						color: "#FFFFFF",
						"&:hover": {
							backgroundColor: "rgba(0, 114, 206, 0.9)",
							color: "#FFFFFF",
						},
					},
					"&.MuiButton-colorWarning": {
						backgroundColor: "#FFFFFF",
						color: "#DC2626",
						"&:hover": {
							backgroundColor: "rgba(255, 255, 255, 0.9)",
							color: "#DC2626",
						},
					},
				},
				outlined: {
					"&.MuiButton-outlinedPrimary": {
						border: "1px solid #FFFFFF",
						color: "#FFFFFF",
						"&:hover": {
							backgroundColor: "#FFFFFF",
							color: "#0072CE",
						},
					},
					"&.MuiButton-outlinedSecondary": {
						border: "1px solid #D4D4D8",
						color: "#0072CE",
						"&:hover": {
							backgroundColor: "#FFFFFF",
							color: "#0072CE",
						},
					},
					"&.MuiButton-colorInherit": {
						border: "1px solid #D4D4D8",
						color: "#09090B",
						"&:hover": {
							backgroundColor: "#FFFFFF",
							color: "#09090B",
						},
					},
					"&.MuiButton-colorError": {
						border: "1px solid #DC2626",
						color: "#DC2626",
						babackgroundColor: "#FEE2E2",
						"&:hover": {
							backgroundColor: "#FEE2E2",
							color: "#DC2626",
						},
					},
					"&.MuiButton-colorInfo": {
						border: "1px solid #0072CE",
						color: "#0072CE",
						babackgroundColor: "#E0EFFE",
						"&:hover": {
							backgroundColor: "#E0EFFE",
							color: "#0072CE",
						},
					},
				},
			},
		},
	},
});

export interface BasicButtonProps extends ButtonProps {
	loading?: boolean;
	disable?: boolean;
}

const BasicButton: React.FC<BasicButtonProps> = ({
	variant,
	className,
	color,
	children,
	disabled,
	disable,
	sx,
	loading = false,
	type = "button",
	...btnProps
}) => {
	return (
		<ThemeProvider theme={theme}>
			<Button
				{...btnProps}
				type={type}
				className={className}
				variant={variant}
				disabled={disabled || disable || loading}
				color={color}
				sx={sx}
			>
				{loading ? (
					<CircularProgress size={16} color="inherit" sx={{ marginX: 2 }} />
				) : null}
				{children}
			</Button>
		</ThemeProvider>
	);
};

export default BasicButton;
